(function () {
  'use strict';

  // --- Expand / Collapse catalog items ---
  function initCatalogExpand() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-catalog-expand]');
      if (!trigger) return;

      var item = trigger.closest('[data-catalog-item]');
      if (!item) return;

      var isExpanded = item.classList.contains('is-expanded');

      document.querySelectorAll('[data-catalog-item].is-expanded').forEach(function (el) {
        if (el !== item) {
          el.classList.remove('is-expanded');
          el.querySelector('[data-catalog-expand]').setAttribute('aria-expanded', 'false');
          var detail = el.querySelector('[data-catalog-detail]');
          if (detail) detail.setAttribute('aria-hidden', 'true');
        }
      });

      if (isExpanded) {
        item.classList.remove('is-expanded');
        trigger.setAttribute('aria-expanded', 'false');
        var detail = item.querySelector('[data-catalog-detail]');
        if (detail) detail.setAttribute('aria-hidden', 'true');
      } else {
        item.classList.add('is-expanded');
        trigger.setAttribute('aria-expanded', 'true');
        var detail = item.querySelector('[data-catalog-detail]');
        if (detail) detail.setAttribute('aria-hidden', 'false');

        setTimeout(function () {
          var rect = item.getBoundingClientRect();
          if (rect.bottom > window.innerHeight) {
            item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }, 360);
      }
    });
  }

  // --- Variant selection inside expanded items ---
  function initVariantSelect() {
    document.addEventListener('change', function (e) {
      var radio = e.target;
      if (!radio.matches('[data-variant-id]')) return;

      var item = radio.closest('[data-catalog-item]');
      if (!item) return;

      var form = item.querySelector('[data-catalog-add-form]');
      if (!form) return;

      form.querySelector('input[name="id"]').value = radio.value;

      var priceDisplay = item.querySelector('.catalog-item__price');
      var priceStr = radio.getAttribute('data-variant-price');
      if (priceDisplay && priceStr) {
        priceDisplay.textContent = priceStr;
      }
    });
  }

  // --- AJAX add-to-cart from catalog items ---
  function initCatalogAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-catalog-add-form]');
      if (!form) return;

      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      var formData = new FormData(form);
      var data = {};
      formData.forEach(function (value, key) {
        data[key] = value;
      });

      fetch(window.DCR.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(data.id), quantity: parseInt(data.quantity || 1) }] })
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          if (json.items) {
            btn.textContent = 'Added!';

            fetch(window.DCR.routes.cart_get, { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                  el.textContent = cart.item_count;
                  el.hidden = cart.item_count === 0;
                });
                window.DCR.cartCount = cart.item_count;
              });

            var notification = document.getElementById('cart-notification');
            if (notification) {
              notification.textContent = 'Item added to cart';
              notification.setAttribute('aria-hidden', 'false');
              notification.classList.add('is-visible');
              setTimeout(function () {
                notification.classList.remove('is-visible');
                notification.setAttribute('aria-hidden', 'true');
              }, 3000);
            }
          } else {
            btn.textContent = 'Error';
          }

          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  }

  // --- Sort select (supports multiple on page) ---
  function initSortSelect() {
    document.querySelectorAll('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    });
  }

  // --- Mobile sidebar drawer toggle ---
  function initSidebarToggle() {
    var sidebar = document.querySelector('[data-catalog-sidebar]');
    var backdrop = document.querySelector('[data-sidebar-close]');
    var toggle = document.querySelector('[data-sidebar-toggle]');
    if (!sidebar || !toggle) return;

    function openSidebar() {
      sidebar.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeSidebar() {
      sidebar.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', openSidebar);
    if (backdrop) backdrop.addEventListener('click', closeSidebar);
  }

  // --- Lazy loading sections with IntersectionObserver ---
  function initLazyLoad() {
    if (!('IntersectionObserver' in window)) return;

    var sections = document.querySelectorAll('[data-catalog-section]');
    if (!sections.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '200px 0px'
    });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  // --- Fetch product previews for directory cards ---
  function initPreviewFetch() {
    if (!('IntersectionObserver' in window)) return;

    var grids = document.querySelectorAll('[data-preview-type]');
    if (!grids.length) return;

    var PREVIEW_COUNT = 4;

    var previewObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var grid = entry.target;
        previewObserver.unobserve(grid);

        var url = grid.getAttribute('data-preview-url');
        if (!url) return;

        fetch(url, { headers: { 'Accept': 'text/html' } })
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var items = doc.querySelectorAll('[data-catalog-item]');

            grid.innerHTML = '';

            var count = Math.min(items.length, PREVIEW_COUNT);
            for (var i = 0; i < count; i++) {
              grid.appendChild(document.importNode(items[i], true));
            }

            if (count === 0) {
              grid.innerHTML = '<p style="color:var(--color-text-light);font-size:0.8125rem;">No preview available</p>';
            }
          })
          .catch(function () {
            grid.innerHTML = '';
          });
      });
    }, {
      rootMargin: '400px 0px'
    });

    grids.forEach(function (grid) {
      previewObserver.observe(grid);
    });
  }

  // --- Sub-filter accordion toggle ---
  function initSubfilterToggle() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-subfilter-toggle]');
      if (!toggle) return;

      var body = toggle.nextElementSibling;
      if (!body) return;

      var isOpen = body.classList.contains('is-open');
      body.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  }

  // --- Init ---
  function init() {
    initCatalogExpand();
    initVariantSelect();
    initCatalogAddToCart();
    initSortSelect();
    initSidebarToggle();
    initSubfilterToggle();
    initLazyLoad();
    initPreviewFetch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
